// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_U5","container":"e_V5","authorText":"e_W5","title":"e_X5","image":"e_Y5","description":"e_Z5","author":"e__5","splitLine":"e_05"};